module.exports = __webpack_public_path__ + "img/gyyd.42fd8fab.png";